import { ResponseRequestGeneric } from "components/Types/GeneralTypes";
import { InformacionUnidadMarcaciones } from "./TypesReporteHojaMarcaciones";
import axios from "axios";
import { authHeader } from "helpers/auth-header";
import config from "config.json"
import { hadleAxiosErrorResponse } from "helpers/handle-response";


const URL_MARCACIONES_CONTROLLER = `${config.SERVER_URL}HojaMarcaciones`;



const URL_CONSULTA_INFORMACION_GENERAL_REPORTE = `${URL_MARCACIONES_CONTROLLER}/InformacionGeneralReporte`;

export async function GetInformacionGeneralReporte() {
    var respuesta: ResponseRequestGeneric<InformacionUnidadMarcaciones[]> = {
        status: -1
    }


    try {
        const response = await axios.get(URL_CONSULTA_INFORMACION_GENERAL_REPORTE, {
            headers: authHeader(),
        })

        respuesta.status = response.status;
        respuesta.dataResponse = response.data;


    } catch (error) {
        respuesta = hadleAxiosErrorResponse(error);
    }

    return respuesta;
}

export function GenerarRutaReporte(fechaDesde: Date, fechaHasta: Date,idEstructura :number,solonovedades:string) {
    const fechaDesdeParse = `${fechaDesde.getFullYear()}-${fechaDesde.getMonth() + 1}-${fechaDesde.getDate()}`
    const fechaHastaParse = `${fechaHasta.getFullYear()}-${fechaHasta.getMonth() + 1}-${fechaHasta.getDate()}`

    return `HojaMarcaciones/InformacionHoja?fechainicio=${fechaDesdeParse}&fechafin=${fechaHastaParse}&idEstructura=${idEstructura}&soloNovedades=${solonovedades}`;



}